import { Button } from "@/components/ui/button";

export const PresetButton = ({ label, icon: Icon, onClick }) => {
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onClick}
      className="gap-2 bg-secondary/30 border-border hover:bg-secondary hover:border-primary/50 transition-colors"
    >
      {Icon && <Icon className="h-3.5 w-3.5 text-primary" />}
      <span className="text-xs">{label}</span>
    </Button>
  );
};
